var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.buttonTag,{tag:"component",class:[
    _vm.baseLayout,
    _vm.baseStyle,
    _vm.size,
    _vm.isDisabled ? _vm.disabledColoring : _vm.coloring,
  ],attrs:{"to":_vm.buttonTag === 'nuxt-link' ? _vm.linkPath : null,"href":_vm.buttonTag === 'a' ? _vm.linkPath : null,"target":_vm.buttonTag === 'a' && _vm.linkPath ? '_blank' : null,"exact":_vm.buttonTag === 'nuxt-link' && _vm.linkPath ? _vm.exact : null,"type":_vm.forForm ? 'submit' : null,"disabled":_vm.isDisabled}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }